import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../../utils/analytics';

export function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    const pageLocation = `${window.location.origin}${pagePath}`;
    const pageTitle = document.title || 'Smart Prompt';

    analytics.trackPageView(pageTitle, pageLocation, pagePath);
  }, [location]);

  return null;
}
